// removed by extract-text-webpack-plugin
module.exports = {"slideError":"AppsCarousel__slideError-3zSQ8","sliderPending":"AppsCarousel__sliderPending-2IFAw"};